import _Array$isArray from "core-js-pure/features/array/is-array.js";
export default function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}